import {skipToken} from '@reduxjs/toolkit/query';

import {useGetModelYearQuery} from '@dms/api/new-vehicle';
import {VatTypeEnum} from '@dms/api/shared';
import {useGetVatRatesOptions} from '@dms/shared';

import {isNotNilOrEmpty, type Nullish} from 'shared/web';

const NEW_MODEL_YEAR_VAT_RATE_TYPE = VatTypeEnum.S;

export function useCatalogueVatRate(modelYearId?: string | Nullish) {
  const {data: modelYear} = useGetModelYearQuery(
    isNotNilOrEmpty(modelYearId) ? {modelYearId} : skipToken
  );
  const [vatOptions] = useGetVatRatesOptions();
  const vatRateType = isNotNilOrEmpty(modelYearId)
    ? modelYear?.vatRateType
    : NEW_MODEL_YEAR_VAT_RATE_TYPE;
  return vatOptions.find(({type}) => type === vatRateType)?.rate;
}
